<template>
    <div>
        <div v-if="busy">
            <BlockUI class="line">
                <div class="new-loading">
                <span></span>
                <span></span>
                <span></span>
                </div>
            </BlockUI>
        </div>
        <div v-else class="kanit consign-address">
            <div  v-if="Page.one === true" class="d-flex flex-column mt-2">
                <div class="px-3 group-input">
                    <div class="form-color-input">
                        <label class="label-primary" for="namelastname">ชื่อ-นามสกุล</label>
                        <b-form-input type="text" placeholder="กรอกชื่อของคุณ" v-model="inputGroup.name" :class="{ 'is-invalid': $v.inputGroup.name.$error }"/>
                        <div v-if="$v.inputGroup.name.$error">
                            <p v-if="!$v.inputGroup.name.required" class="invalid-feedback d-block">กรุณากรอกชื่อ-นามสกุล</p>
                        </div>
                    </div>
                    <div class="form-color-input mt-2">
                        <label class="label-primary" for="tel">เบอร์โทรศัพท์</label>
                        <b-form-input type="text" placeholder="กรอกเบอร์โทรศัพท์ที่สามารถติดต่อได้" v-model="inputGroup.tel" :class="{ 'is-invalid': $v.inputGroup.tel.$error }"/>
                        <div v-if="$v.inputGroup.tel.$error">
                            <p v-if="!$v.inputGroup.tel.required" class="invalid-feedback d-block">กรุณากรอกเบอร์โทรศัพท์</p>
                        </div>
                    </div>
                    <div class="form-color-input mt-2">
                        <label class="label-primary" for="address">รายละเอียดที่อยู่</label>
                        <b-form-textarea
                        :class="{ 'is-invalid': $v.inputGroup.address.$error }"
                        v-model="inputGroup.address"
                        placeholder="เช่น บ้านเลขที่ ซอย ถนน เป็นต้น"
                        rows="2"
                        max-rows="3"
                        ></b-form-textarea>
                        <div v-if="$v.inputGroup.address.$error">
                            <p v-if="!$v.inputGroup.address.required" class="invalid-feedback d-block">กรุณากรอกรายละเอียดที่อยู่</p>
                        </div>
                    </div>
                    <div class="mt-2">
                        <div class="mt-3">
                            <div 
                            :class="{ 'is-invalid': $v.inputGroup.formatAddress.$error }"
                            class="box-model form-control d-flex justify-content-between align-items-center cursor-pointer" @click="changeSlideOnsearch()">
                                <div class="cursor-pointer">
                                {{ inputGroup.formatAddress }}
                                </div>
                                <span class="cursor-pointer">
                                    <img :src="iconUrl.iconmore"/>
                                </span>
                            </div>
                            <div v-if="$v.inputGroup.formatAddress.$error">
                                <p v-if="!$v.inputGroup.formatAddress.required" class="invalid-feedback d-block">กรุณาเลือกตำบล/อำเภอ/เขต/จังหวัด</p>
                            </div>
                        </div>
                    </div>
                    <div class="form-color-input mt-2">
                        <label class="label-primary">
                            ติดป้าย <span class="text-line-muted">(ไม่บังคับ)</span>
                        </label>
                        <div class="d-flex flex-row tags-select">
                            <div class="box-select" :class="inputGroup.tags === 'home' ? 'active' : ''" @click="changTags('home')">
                                <img class="" :src="inputGroup.tags === 'home' ? iconUrl.homeactive : iconUrl.home" />
                                บ้าน
                            </div>
                            <div class="box-select ml-3" :class="inputGroup.tags === 'office' ? 'active' : ''" @click="changTags('office')">
                                <img class="" :src="inputGroup.tags === 'office' ? iconUrl.officeactive : iconUrl.office" />
                                ออฟฟิศ
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-start mt-3">
                        <div class="custom-checkbox cursor-pointer" @click="onChangeAddress">
                            <input type="checkbox" v-model="checkedNewAddress"/>
                            <div class="custom-checkbox-circle cursor-pointer">
                            </div>
                        </div>
                        <div class="ml-3 cursor-pointer" @click="onChangeAddress">
                            <span>
                                ที่อยู่เริ่มต้นในการจัดส่ง
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else :class="Page.one === true ? 'dialog-reverse' : 'dialog px-3'">
                <label for="ที่อยู่">ค้นหาที่อยู่</label>
                <thai-address-input type="search"
                    v-model="inputGroup.formatAddressSelect"
                    input-class="form-control"
                    @selected="onSearchedInputGroup"
                    placeholder="กรอกที่อยู่ของคุณที่นี่"
                    >
                </thai-address-input>
                <div class="image-empty w-100 mt-5">
                    <img src="../../assets/images/line/emptyaddress.png" alt="">
                </div>
                <div>
                    <h1 class="header-empty">
                        ค้นหาที่อยู่ของคุณ
                    </h1>
                    <h3 class="description-empty">
                        เช่น ตำบล , อำเภอ , จังหวัด , รหัสไปรษณีย์
                    </h3>
                </div>
            </div>
            <div class="line-fixed-bottom my-2 w-100 px-3 group-input">
                <div class="d-flex flex-column">
                    <b-button variant="line-primary" class="mt-2" block @click="setSenderAPI">บันทึก</b-button>
                    <b-button variant="outline-line-primary" class="mt-2 hover-button-primary" block @click="closeTab">กลับสู่ Chat</b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { required, minLength } from "vuelidate/lib/validators";
import { switchLiff } from "@/constants/Lineliff"
const context_line = JSON.parse(localStorage.getItem('context_line'))

export default {
    metaInfo: {
    //   title: this.$route.query.action === 'addSender' ? 'เพิ่มที่อยู่ผู้ส่ง' : this.$route.query.action === 'editSender' ? 'แก้ไขที่อยู่' : 'สมุดที่อยู่',
    },
    data() {
        return {
            busy: true,
            Page: {
                one: true,
                two: false,
            },
            inputGroup: {
                name: '',
                address: '',
                tel: '',
                state: '',
                province: '',
                postcode: '',
                district: '',
                formatAddress: '',
                formatAddressSelect: '',
                tags: ''
            },
            iconUrl : {
                iconmore: require('../../assets/icon/iconmore.svg'),
                home: require("../../assets/icon/iconhome.svg"),
                office: require("../../assets/icon/iconoffice.svg"),
                homeactive: require("../../assets/icon/iconhomeactive.svg"),
                officeactive: require("../../assets/icon/iconofficeactive.svg"),
            },
            checkedNewAddress: false,
        }
    },
    validations: {
        inputGroup: {
            name: { required },
            tel: { required, minLength: minLength(9) },
            address: { required },
            state: { required },
            province: { required },
            postcode: { required },
            district: { required },
            formatAddress: { required }
        },
    },
    methods: {
        closeTab() {
            this.$liff.closeWindow();
        },
        changeSlideOnsearch() {
            this.Page.one = false;
            this.Page.two = true;
        },
        changTags(key) {
            this.inputGroup.tags = key
        },
        onChangeAddress() {
            this.checkedNewAddress = !this.checkedNewAddress
        },
        onSearchedInputGroup(address) {
            this.inputGroup.state = address.subdistrict;
            this.inputGroup.district = address.district;
            this.inputGroup.province = address.province;
            this.inputGroup.postcode = address.postalCode;
            this.inputGroup.formatAddress = address['subdistrict'] + '>' + address['district'] + '>' + address['province'] + '>' +address['postalCode']
            this.Page.one = true;
            this.Page.two = false;
        },
        setSenderAPI() {
            this.$v.inputGroup.$touch();
            if( this.$v.inputGroup.$invalid ) {
                return false
            }
            const allowedActions = ['addSender', 'editSender', 'addFromBookSender', 'editFromBookSender'];

            if (!allowedActions.includes(this.$route.query.action)) {
              this.$router.push('/location/timeout');
            }
            
            const body = {
                name: this.inputGroup.name,
                address: this.inputGroup.address,
                tel: this.inputGroup.tel,
                state: this.inputGroup.state,
                province: this.inputGroup.province,
                postcode: this.inputGroup.postcode,
                district: this.inputGroup.district,
                tags: this.inputGroup.tags,
                actionDefault: this.checkedNewAddress
            }
            const headers = {
                headers: {
                  Token: localStorage.getItem('access_token_customer')
                }
            }
            const senderId = this.$route.query.senderId

            this.busy = true
            if(this.$route.query.action === 'addSender' || this.$route.query.action === 'addFromBookSender') {
                this.$http.post(this.$API_URL + `/line/add/sender`, body, headers).then((res) => {
                    const status = res.data.status
                    if(!status) {
                        return this.$router.push('/location/timeout')
                    }
                    if(this.$route.query.action === 'addSender') {
                        switchLiff('', 'FULL', 'showsenders')
                    }else if (this.$route.query.action === 'addFromBookSender') {
                        switchLiff('', 'FULL', 'booksender')
                    }
                }).finally(() => {
                    this.closeBusy()
                })
            }else if(this.$route.query.action === 'editSender' || this.$route.query.action === 'editFromBookSender') {
                this.$http.post(this.$API_URL + `/line/edit/sender/${senderId}`, body, headers).then((res) => {
                    const status = res.data.status
                    if(!status) {
                        return this.$router.push('/location/timeout')    
                    }
                    if(this.$route.query.action === 'editSender') {
                        switchLiff('', 'TALL', 'showsenders')
                    }else if (this.$route.query.action === 'editFromBookSender') {
                        switchLiff('', 'FULL', 'booksender')
                    }
                }).finally(() => {
                    this.closeBusy()
                })
            }
        },
        getEditSender() {
            const headers = {
                headers: {
                  Token: localStorage.getItem('access_token_customer')
                }
            }
            const senderId = this.$route.query.senderId
            this.$http.post(this.$API_URL + `/line/get/sender/${senderId}`, {}, headers).then((res) => {
                const status = res.data.status
                if(!status) {
                    return this.$router.push('/location/timeout')
                }
                const resData = res.data.data
                this.inputGroup.name = resData['name']
                this.inputGroup.address = resData['address']
                this.inputGroup.tel = resData['tel'].trim()
                this.inputGroup.state = resData['state']
                this.inputGroup.district = resData['district']
                this.inputGroup.province = resData['province']
                this.inputGroup.postcode = resData['postcode']
                this.inputGroup.tags = resData['tags']
                this.inputGroup.formatAddress = (!resData['state'] || !resData['district'] || !resData['province'] || !resData['postcode']) ? '' : resData['state'] + ' > ' + resData['district'] + ' > ' + resData['province'] + ' > ' +resData['postcode']
                this.checkedNewAddress = resData['setSender']
                this.busy = false
            })
        },
        closeBusy() {
            this.busy = false
        }
    },
    mounted() {
        this.$liff.init({
            liffId: context_line.liffId
        })
        console.log('what action: ', this.$route.query)
        if(this.$route.query.action === 'addSender' || this.$route.query.action === 'addFromBookSender') {
            this.closeBusy()
        }else if(this.$route.query.action === 'editSender' || this.$route.query.action === 'editFromBookSender') {
            this.getEditSender()
        }
    }
}
</script>
